module.exports = __webpack_public_path__ + "65e9e2be5989d795d43a6700100031d2.svg";